<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="年份" prop="year">
                <el-date-picker v-model="queryCondition.year" value-format="yyyy" format="yyyy" type="year" placeholder="选择年" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Sponsor" prop="sponsorName">
                <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <el-button size="mini" @click="onExport" type="primary">导出</el-button>
          </el-row>
        </el-form>
      </div>
      <el-table ref="multipleTable" :data="tableData" border style="width: 100%">
        <el-table-column prop="yearQuarter" label="日期"></el-table-column>
        <el-table-column prop="sponsorName" label="供应商"></el-table-column>
        <el-table-column prop="action" label="操作"></el-table-column>
        <el-table-column prop="userName" label="更新人"></el-table-column>
        <el-table-column prop="createDate" label="更新日期"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import rmcProtFeedPlantApi from "@/api/rmcProtein/feedPlant";
import commonFunction from "@/utils/dataTableUtils";
import { fileService } from "@/api/common/file-utils";
export default {
  name: '',
  components: {
  },
  data() {
    return {
      tableData: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        sponsorName: "",
        year: "",
      },
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {

  },
  mounted() {
    this.$nextTick(() => {
      this.queryData();
    })
  },
  methods: {
    queryData() {
      rmcProtFeedPlantApi.updateLog(this.queryCondition).then(res => {
        console.log('更新日志', res);
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        this.pages = res.pages;
      });
    },
    onExport(){
      rmcProtFeedPlantApi.downloadUpdateLogList(this.queryCondition).then(res => {
        fileService.respToFile(res, 'Protein_饲料厂清单_更新日志报表.xlsx');
      });
    },
    onSearch() {
      this.queryCondition.pageNum = 1
      this.queryCondition.pageSize = 15
      this.queryData()
    },
    handleSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['queryCondition'].resetFields()
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        sponsorName: "",
        year: "",
      }
      this.queryData();
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
